module.exports = __webpack_public_path__ + "static/media/helsinki.65e999da.png";